export const MessageCode = {
    RefundFailed: "pg_03"
}